module.exports = __webpack_public_path__ + "static/media/01n.a29bb72e.png";